import React from "react";
import { TableColumn } from "../../../../components/table/Table";
import { ArticleProps } from "../../../../models";
import { AccountTag } from "../../../Templates/components/table/TemplateCells";
import {
  ActionsCell,
  CreatedCell,
  EngineCell,
  ImageEngineCell,
  PostedCell,
  SourceCell,
  StatusCell,
  TemplateCell,
  TitleCell,
  TokensCell,
  WordsCell,
} from "./ArticleCells";

export const getArticleColumns = (
  onAction: Function,
  isSuper: boolean
): TableColumn<ArticleProps>[] => [
  {
    key: "title",
    title: "Title",
    headerClassName: "text-left",
    render: (a) => (
      <TitleCell
        article={a}
        onAction={onAction}
      />
    ),
  },
  {
    key: "source",
    title: "Source",
    headerClassName: "text-center",
    render: (a) => (
      <SourceCell
        article={a}
        onAction={onAction}
      />
    ),
  },
  {
    key: "templateName",
    title: "Template",
    headerClassName: "text-left",
    render: (a) => <TemplateCell article={a} />,
  },
  {
    key: "articleWordCount",
    title: "Words",
    headerClassName: "text-left",
    render: (a) => <WordsCell article={a} />,
  },
  {
    key: "tokensUsed",
    title: "Tokens Used",
    headerClassName: "text-left whitespace-nowrap",
    render: (a) => <TokensCell article={a} />,
  },
  ...(isSuper
    ? [
        {
          key: "engineId",
          title: "Engine",
          headerClassName: "text-left",
          render: (a: ArticleProps) => <EngineCell article={a} />,
        },
        {
          key: "imageEngineId",
          title: "Image Engine",
          headerClassName: "text-left whitespace-nowrap",
          render: (a: ArticleProps) => <ImageEngineCell article={a} />,
        },
      ]
    : []),
  {
    key: "accountTagName",
    title: "Tag",
    headerClassName: "text-left w-[5%]",
    cellClassName: "max-w-32",
    render: (a: ArticleProps) => (
      <AccountTag accountTagName={a?.accountTagName!} />
    ),
  },
  {
    key: "articleStatusId",
    title: "Status",
    headerClassName: "text-center",
    render: (a) => <StatusCell article={a} />,
  },
  {
    key: "createdAt",
    title: "Created",
    headerClassName: "text-left",
    render: (a) => <CreatedCell article={a} />,
  },
  {
    key: "postedAt",
    title: "Posted",
    headerClassName: "text-center",
    render: (a) => <PostedCell article={a} />,
  },
  {
    key: "actions",
    title: "",
    render: (a) => (
      <ActionsCell
        article={a}
        onAction={onAction}
      />
    ),
  },
];
